// Regras de texto iguais no Worker (captura) e no app (nota rápida, compartilhamento).

/** "Texto entre aspas", com atribuição opcional depois do travessão (§4.2 Citação). */
export const isQuoteText = (text: string) => /^["“«„][^"“”«»„]{2,}["”»“](\s*[—–-]{1,2}\s*\S[\s\S]*)?$/.test(text.trim());
